import announce from "../../00-base/global/utils/announce";
/**
 * Initializes exhibition page functionality.
 *
 * @param context
 */
const initFilterBar = function(context) {
  if (context && context.matches && context.matches('.exhibition-landing--list, .exhibition-landing')) {
    const ajax_status = document.querySelector(".js-ajax-status");
    if (ajax_status) {
      const announcementText = context.matches(".empty-content") ? getEmptyMessage(context) : ajax_status.dataset.finishedSuccess;
      announce(announcementText, ajax_status);
    }
  }
};

function getEmptyMessage(context) {
  return Array.from(context.querySelectorAll('.view-empty-message'))
    .map((emptyEl) => emptyEl.textContent)
    .join(" ")
    .trim();
}
export default initFilterBar;
